namespace Areas.Finance.DailyGL {
    "use strict";

    let accountId: number = 0;
    let cc: string;
    let project: string;
    let fund: string;

    export function goToActions() {
        return (e: any) => {
            if (e.value == 1) {
                Areas.Finance.DailyGL.goToProject(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                Areas.Finance.DailyGL.goToSharePoint(e);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    export function goToSharePoint(e: any) {
        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var sharePointLink = row[0].sharePointLink;
            let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
            if (sharePointLink != "") {
                window.open(linkInfo);
            }
            else {
                window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
            }
        }
    }

    export function viewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            "<a href= '/Account/Profile/View/{placeholder}' target=\"_blank\">View</a>");
    }

    export function goToProject(e: any) {
        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Project/Profile/View/" + id;
            location.href = linkInfo;
        }
    }

    export function autoFundTransfer(e: any) {
        sendRequest("/Finance/DailyGL/ExecuteAutoFundTransfer",
            null,
            "PUT",
            c => {
                Areas.refreshGrid("DailyGLGrid");
                Areas.refreshGrid("DailyGLMemoGrid");
            });
    }

    export function onSummaryGridSelectionChanged(e: any) {
        const grid = $("#DailyGLSummaryGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            accountId = row[0].accountId;
            cc = row[0].accountNumber;
            project = row[0].projectNumber;
            fund = row[0].fundNumber;
            Areas.refreshGrid("DailyGLGrid");
            Areas.refreshGrid("DailyGLMemoGrid");
        }
    }

    export function onContentReady(e: any) {
        const grid = $("#DailyGLSummaryGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

    }

    export function getFund() {
        return fund;
    }

    export function getAccountId() {
        return accountId;
    }

    export function getAccount() {
        return cc;
    }

    export function getProject() {
        return project;
    }

    export function disableAllButtons() {
        disableButton("AutoFund");
        disableButton("Research");
        disableButton("Capitalize");
        disableButton("Exclude");
        disableButton("Transfer");
        disableButton("Reconcile");
    }

    export function enableAllButtons() {
        enableButton("AutoFund");
        enableButton("Research");
        enableButton("Capitalize");
        enableButton("Exclude");
        enableButton("Transfer");
        enableButton("Reconcile");
    }



    export function checkTotalsForSelected(e: any) {

        disableAllButtons();

        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const selectedDownload = grid.getSelectedRowsData();

        const gridMemos = $("#DailyGLMemoGrid").dxDataGrid("instance");
        const selectedMemos = gridMemos.getSelectedRowsData();

        let aisTotal: number = 0;
        let memoTotal: number = 0;
        let diff: number = 0;
        let diffTotal: string;

        for (var i = 0; i < selectedDownload.length; i++) {
            aisTotal = aisTotal + selectedDownload[i].trans_amount_gl;
        }

        for (var i = 0; i < selectedMemos.length; i++) {
            memoTotal = memoTotal + selectedMemos[i].glAmount;
        }

        diff = parseFloat((aisTotal - memoTotal).toFixed(2));
        diffTotal = (aisTotal - memoTotal).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

        if (diff != 0) {
            const okToProceed =
                window.confirm(" AIS selected Record Total: " +
                    aisTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +
                    "\r\n" +
                    " GL Memo selected Record Total: " +
                    memoTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') +
                    "\r\n" +
                    " Difference:  " +
                    diffTotal +
                    "\r\n" +
                    " Proceed with Reconcile? ");

            if (okToProceed) {
                reconcileSelected();
            } else {
                enableAllButtons();
            }

        } else {
            reconcileSelected();
        }

    }


    export function reconcileSelected() {
        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const selectedDownload = grid.getSelectedRowsData();

        const gridMemos = $("#DailyGLMemoGrid").dxDataGrid("instance");
        const selectedMemos = gridMemos.getSelectedRowsData();


        var data = JSON.stringify(
            {
                "AISDownloadGLs": selectedDownload,
                "GLMemos": selectedMemos
            });

        sendRequest("/Finance/DailyGL/ReconcileDownloadMemos",
            data,
            "PUT",
            c => {
                Areas.refreshGrid("DailyGLGrid");
                Areas.refreshGrid("DailyGLMemoGrid");
                enableAllButtons();
            });

    }


    export function checkTransfers() {
        disableAllButtons();
        checkTransfersResearch(false);
    }

    export function checkTransfersResearch(includeResearch) {
        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const selectedData = grid.getSelectedRowsData();
        var errorCheckClosedAccount: boolean = false;
        var accountNum: string = "";

        const gridSummary = $("#DailyGLSummaryGrid").dxDataGrid("instance");
        const rowSummary = gridSummary.getSelectedRowsData();
        const rowSummaryAll = gridSummary.getDataSource().items();


        if (selectedData.length == 0 || selectedData.length > 9) {
            transferSelected(includeResearch);
            enableAllButtons();
            return;
        }

        if (rowSummary.length == 1) {
            if (rowSummary[0].accountStatus != "Closed" &&
                rowSummary[0].accountStatus != "InActive") {
                transferSelected(includeResearch);
                errorCheckClosedAccount = true;
                enableAllButtons();
                return;
            } else {
                transferConfirmation(includeResearch);
                enableAllButtons();
                return;
            }
        }

        for (var i = 0; i < selectedData.length; i++) {
            for (var j = 0; j < rowSummaryAll.length; j++) {
                if (rowSummaryAll[j].projectNumber == selectedData[i].account_number &&
                    rowSummaryAll[j].accountNumber == selectedData[i].cost_center_code &&
                    rowSummaryAll[j].fundNumber == selectedData[i].fund_number &&
                    (rowSummaryAll[j].accountStatus == "Closed" || rowSummaryAll[j].accountStatus == "InActive")) {

                    errorCheckClosedAccount = true;
                }
            }
        }

        if (errorCheckClosedAccount) {
            transferConfirmation(includeResearch);
            return;
        } else {
            transferSelected(includeResearch);
            return;
        }

    }

    export function transferConfirmation(includeResearch) {
        const okToProceed =
            window.confirm(" Account was CLOSED or Inactive: " +
                "\r\n" +
                " Proceed with TRANSFER? ");

        if (okToProceed) {
            transferSelected(includeResearch);
        }
    }




    function transferSelected(includeResearch) {

        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const selectedData = grid.getSelectedRowsData();


        var data = JSON.stringify(
            {
                "AISDownloadGLs": selectedData
            });

        var url = "/Finance/DailyGL/TransferAISDownload/?includeResearch=" + includeResearch;

        sendRequest(url,
            data,
            "PUT",
            c => {
                Areas.refreshGrid("DailyGLGrid");
                enableAllButtons();
            });
    }     

    export function capitalizeSelected(e: any) {
        disableAllButtons();
        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const selectedData = grid.getSelectedRowsData();


        var data = JSON.stringify(
            {
                "AISDownloadGLs": selectedData
            });

        sendRequest("/Finance/DailyGL/CapitalizeAISDownload", data, "PUT", c => {
            Areas.refreshGrid("DailyGLGrid");
            enableAllButtons();
        });
    }

    export function excludeSelected(e: any) {
        disableAllButtons();
        const grid = $("#DailyGLGrid").dxDataGrid("instance");
        const selectedData = grid.getSelectedRowsData();


        var data = JSON.stringify(
            {
                "AISDownloadGLs": selectedData
            });

        sendRequest("/Finance/DailyGL/ExcludeAISDownload", data, "PUT", c => {
            Areas.refreshGrid("DailyGLGrid");
            enableAllButtons();
        });
    }

    export function unSelectRow(e: any) {

        const grid: any = $("#DailyGLSummaryGrid").dxDataGrid("instance");
        grid.unselectAll;
        grid.repaint;
        DisplayAllDetail();
    }

    export function updateGL(e: any) {
        return;
    }

    function DisplayAllDetail() {
        accountId = 0;
        Areas.refreshGrid("DailyGLSummaryGrid");
    }

    export function addResearch() {
        checkTransfersResearch(true);
    }
        
        
}